export const TermsOfServicePage = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-indigo-950 via-purple-950 to-indigo-950 text-white p-6 overflow-y-auto">
      <div className="max-w-3xl mx-auto py-8">
        <h1 className="text-4xl font-bold mb-8 text-center">
          Terms of Service
        </h1>
        <p className="text-gray-300 mb-8 text-center hidden">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </p>

        <div className="space-y-8 text-gray-200">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              1. Acceptance of Terms
            </h2>
            <p className="leading-relaxed">
              By accessing or using Sanctum of Sorcery ("the Game"), you agree
              to be bound by these Terms of Service ("Terms"). If you do not
              agree to these Terms, please do not use the Game. We reserve the
              right to modify these Terms at any time, and your continued use
              constitutes acceptance of any changes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              2. Eligibility
            </h2>
            <p className="leading-relaxed">
              You must be at least 18 years old or the age of majority in your
              jurisdiction to use the Game. By using the Game, you represent and
              warrant that you meet these eligibility requirements and have the
              legal capacity to enter into these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              3. Account and Wallet
            </h2>
            <div className="space-y-4">
              <p className="leading-relaxed">
                To play the Game, you must connect a compatible cryptocurrency
                wallet. You are solely responsible for:
              </p>
              <ul className="list-disc list-inside space-y-2 leading-relaxed">
                <li>
                  Maintaining the security of your wallet and private keys
                </li>
                <li>All activities that occur through your connected wallet</li>
                <li>Ensuring you have sufficient funds for transactions</li>
                <li>Understanding blockchain transaction fees (gas fees)</li>
              </ul>
              <p className="leading-relaxed">
                We are not responsible for any loss of funds due to compromised
                wallets or user error.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              4. Game Rules and Fair Play
            </h2>
            <p className="leading-relaxed mb-4">You agree to:</p>
            <ul className="list-disc list-inside space-y-2 leading-relaxed">
              <li>
                Play the Game fairly and not use cheats, exploits, or
                unauthorized modifications
              </li>
              <li>
                Not use bots, scripts, or automated systems to gain unfair
                advantages
              </li>
              <li>
                Not engage in any form of market manipulation or fraudulent
                activity
              </li>
              <li>
                Treat other players with respect and not engage in harassment
              </li>
              <li>Report bugs and exploits rather than abusing them</li>
            </ul>
            <p className="leading-relaxed mt-4">
              Violation of these rules may result in account suspension or
              permanent ban.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              5. In-Game Purchases and Transactions
            </h2>
            <div className="space-y-4">
              <p className="leading-relaxed">
                The Game may offer in-game purchases using cryptocurrency. By
                making a purchase:
              </p>
              <ul className="list-disc list-inside space-y-2 leading-relaxed">
                <li>
                  You acknowledge all blockchain transactions are final and
                  non-refundable
                </li>
                <li>
                  You accept responsibility for verifying transaction details
                  before confirming
                </li>
                <li>
                  You understand the value of digital assets may fluctuate
                </li>
                <li>You accept any applicable transaction fees</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              6. Intellectual Property
            </h2>
            <p className="leading-relaxed">
              All content in the Game, including but not limited to graphics,
              gameplay mechanics, audio, text, and software, is owned by Sanctum
              of Sorcery or its licensors and is protected by intellectual
              property laws. You are granted a limited, non-exclusive,
              non-transferable license to use the Game for personal,
              non-commercial purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              7. Digital Assets and NFTs
            </h2>
            <p className="leading-relaxed">
              Any digital assets or NFTs acquired through the Game are subject
              to the underlying blockchain's terms and conditions. We make no
              guarantees regarding the future value, utility, or transferability
              of any digital assets. Ownership of digital assets does not grant
              any intellectual property rights beyond what is explicitly stated.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              8. Disclaimer of Warranties
            </h2>
            <p className="leading-relaxed">
              THE GAME IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES
              OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE GAME
              WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE. WE DISCLAIM ALL
              WARRANTIES INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR
              PURPOSE, AND NON-INFRINGEMENT.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              9. Limitation of Liability
            </h2>
            <p className="leading-relaxed">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR
              ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
              DAMAGES, INCLUDING LOSS OF PROFITS, DATA, OR DIGITAL ASSETS,
              ARISING FROM YOUR USE OF THE GAME. OUR TOTAL LIABILITY SHALL NOT
              EXCEED THE AMOUNT YOU PAID TO US IN THE PAST 12 MONTHS.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              10. Indemnification
            </h2>
            <p className="leading-relaxed">
              You agree to indemnify and hold harmless Sanctum of Sorcery, its
              affiliates, and their respective officers, directors, employees,
              and agents from any claims, damages, losses, or expenses arising
              from your use of the Game or violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              11. Governing Law
            </h2>
            <p className="leading-relaxed">
              These Terms shall be governed by and construed in accordance with
              applicable laws, without regard to conflict of law principles. Any
              disputes arising from these Terms or your use of the Game shall be
              resolved through binding arbitration.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              12. Termination
            </h2>
            <p className="leading-relaxed">
              We reserve the right to suspend or terminate your access to the
              Game at any time, with or without cause, and with or without
              notice. Upon termination, your right to use the Game will
              immediately cease.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              13. Contact Us
            </h2>
            <p className="leading-relaxed">
              If you have any questions about these Terms, please contact us at:{' '}
              <a
                href="mailto:admin@mochi-studio.net"
                className="text-orange-400 hover:underline"
              >
                admin@mochi-studio.net
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="inline-block px-6 py-3 bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-semibold rounded-xl border-2 border-black hover:scale-105 transition-transform"
          >
            Back to Game
          </a>
        </div>
      </div>
    </div>
  );
};
